import React from 'react';
import { ControlProps, components } from 'react-select';
import { SelectOption } from '../MultiFilterDropdown';

interface ControlMultiComponentProps<T> {
  props: ControlProps<SelectOption<T>, true>;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function ControlMultiComponent<T>({
  props,
  setIsOpen,
}: ControlMultiComponentProps<T>) {
  return (
    <div
      onClick={(event) => {
        const remove = (event.target as HTMLElement).closest(
          '.removeMultiValue'
        );
        if (remove === null) {
          setIsOpen((prev) => !prev);
        }
      }}
    >
      <components.Control {...props} />
    </div>
  );
}

export default ControlMultiComponent;
